var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card p-1" }, [
      _c(
        "span",
        { staticClass: "font-small-2 text-bold-700 mb-05 text-left" },
        [_vm._v(_vm._s(_vm.__("question.headers.member.invite_users")))]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.triggerUserInviteModal.apply(null, arguments)
            },
          },
        },
        [
          _vm._v(
            "\n                " +
              _vm._s(_vm.__("question.form.buttons.invite_users")) +
              "\n        "
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm.show_invite_modal
      ? _c(
          "div",
          [
            _c("InviteUsersModal", {
              attrs: { module_id: this.module_id },
              on: { "close-modal": _vm.triggerUserInviteModal },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }